module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pageSize !== 'M') ? _c('div', {
    staticClass: "mainProduct__shareWrap"
  }, [(_vm.pageSize === 'L') ? _c('a', {
    staticClass: "mainProduct__shareBtn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showShare.apply(null, arguments)
      }
    }
  }, [_vm._v("Share it!\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shareIsVisiable),
      expression: "shareIsVisiable"
    }],
    staticClass: "mainProduct__shareWindow"
  }, [(_vm.pageSize === 'L') ? _c('h5', {
    staticClass: "mainProduct__shareHeader"
  }, [_vm._v("\n      Share width\n    ")]) : _vm._e(), _vm._v(" "), (_vm.pageSize === 'L') ? _c('a', {
    staticClass: "mainProduct__shareClose",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.hideShare.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "mainProduct__shareList"
  }, _vm._l((_vm.social), function(item, index) {
    return _c('li', [_c('a', {
      key: index,
      staticClass: "mainProduct__shareLink",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.getShare.apply(null, arguments)
        }
      }
    }, [_c('img', {
      staticClass: "mainProduct__shareImg",
      attrs: {
        "src": './src/assets/share/' + item,
        "alt": "item"
      }
    })])])
  }), 0)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f7f7b13","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainShare.vue
// module id = 55
// module chunks = 0